module.exports = __webpack_public_path__ + "img/icone-webhook-shapefile.6d54c1ae.svg";